import { useTranslation } from 'react-i18next'
import { Button, Container, Group, Paper, Stack, Text, Title } from '@mantine/core'
import { Head, usePage } from '@inertiajs/react'
import HeliviewLogo from '../components/HeliviewLogo'
import LanguageSelect from '../components/LanguageSelect'

export default function DigestUnsubscribe({ token, done }) {
  const { t } = useTranslation()
  const { csrf_token } = usePage().props
  return <><Head title={t("Weekoverzicht uitzetten")}/><Container size={520} py={80}>
    <Group justify="space-between" mb={40}><Group gap="sm"><HeliviewLogo size={26}/><Text fw={750} size="lg">Heliview Kanban</Text></Group><LanguageSelect/></Group>
    <Paper withBorder p="xl"><Stack>
      <Title order={1} size="h3">{t("Weekoverzicht uitzetten")}</Title>
      {done ? <Text>{t("Het weekoverzicht staat uit. Je kunt het weer aanzetten in het menu naast je naam in Heliview Kanban.")}</Text>
      : <><Text>{t("Je ontvangt dan geen maandagmail meer met je taken die te laat zijn, deze week aflopen of overlappen.")}</Text>
        <form method="post" action="/digest/unsubscribe"><input type="hidden" name="authenticity_token" value={csrf_token}/><input type="hidden" name="token" value={token}/><Button type="submit">{t("Weekoverzicht uitzetten")}</Button></form></>}
    </Stack></Paper>
  </Container></>
}
